import { render, staticRenderFns } from "./vehicle-selected-card.vue?vue&type=template&id=82d30b8c&scoped=true"
import script from "./vehicle-selected-card.vue?vue&type=script&lang=js"
export * from "./vehicle-selected-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d30b8c",
  null
  
)

export default component.exports